import { Tabs } from "antd";
import type { TabsProps } from "antd";
import DesignTimeTable from "./DesignTimeTable";
import RunTimeTable from "./RunTimeTable";
import styles from "./style";
import ChecksheetDashboard from "./ChecksheetDashboard";
import { FaEdit } from "react-icons/fa";
import { AiOutlineDashboard, AiOutlineFileText } from "react-icons/ai";
const CheckSheet = () => {
  const classes = styles();
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <FaEdit /> Forms Library
        </span>
      ),
      children: <DesignTimeTable />,
    },
    {
      key: "2",
      label: (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <AiOutlineFileText /> Reports
        </span>
      ),
      children: <RunTimeTable />,
    },
    {
      key: "3",
      label: (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <AiOutlineDashboard /> Dashboards
        </span>
      ),
      children: <ChecksheetDashboard />,
    },
  ];

  return (
    <div className={classes.tabsWrapper}>
      <Tabs
        defaultActiveKey="3"
        items={items}
        style={{ margin: "0 0 0 20px" }}
      />
      {/* <DesignTimeTable /> */}
    </div>
  );
};

export default CheckSheet;
